<template>
  <path
    d="M12 2.00018C6.48 2.00018 2 6.48018 2 12.0002C2 17.5202 6.48 22.0002 12 22.0002C17.52 22.0002 22 17.5202 22 12.0002C22 6.48018 17.52 2.00018 12 2.00018ZM11 15.0002C11 15.5502 10.55 16.0002 10 16.0002C9.45 16.0002 9 15.5502 9 15.0002V9.00018C9 8.45018 9.45 8.00018 10 8.00018C10.55 8.00018 11 8.45018 11 9.00018V15.0002ZM16.02 12.7802L13.62 14.7002C12.97 15.2202 12 14.7602 12 13.9202V10.0802C12 9.24018 12.97 8.78018 13.62 9.30018L16.02 11.2202C16.52 11.6202 16.52 12.3802 16.02 12.7802Z"
  />
</template>
